import type { ReactNode } from "react";
import { TableDemo } from "../DataTable";
import { CountSkeleton } from "../CountSkeleton";

interface StatCardProps {
  backgroundImage: string;
  title: string;
  description: string;
  value: ReactNode;
}

const StatCard = ({
  backgroundImage,
  title,
  description,
  value,
}: StatCardProps) => {
  return (
    <div
      className="w-full h-[100px] tablet:h-full rounded-2xl bg-cover bg-center relative flex flex-col justify-between px-5 py-[10px] desktop:px-6 desktop:py-4"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="text-white flex flex-col">
        <span className="text-heading-2-mb desktop:text-heading-1">
          {title}
        </span>
        <span className="text-body-2-mb desktop:text-body-1">
          {description}
        </span>
      </div>
      <div className="w-full flex justify-end">
        <span className="text-white font-bold text-3xl desktop:text-6xl">
          {value}
        </span>
      </div>
    </div>
  );
};

interface StatsSectionProps {
  suimCount: number | null;
}

export const StatsSection = ({ suimCount }: StatsSectionProps) => {
  return (
    <section className="max-w-[1170px] mx-auto px-[16px] tablet:px-[32px] desktop:px-3 py-[80px] flex flex-col gap-[32px] tablet:justify-center break-keep desktop:pt-[76px] desktop:pb-[160px]">
      <div className="flex flex-col gap-[8px] text-center desktop:gap-[20px]">
        <div className="text-heading-1-mb desktop:text-heading-1 text-[#212121]">
          수많은 소송 경험
        </div>
        <div className="text-body-2-mb desktop:text-body-1 text-[#4F4F4F]">
          신뢰할 수 있는 경력의 변호사분들의 지원으로{" "}
          <br className="desktop:hidden" />
          소송 문제를 효과적으로 해결하고 있습니다
        </div>
      </div>
      <div className="flex flex-col gap-4 tablet:flex-row tablet:gap-5">
        <div className="flex flex-col gap-2 flex-1">
          <StatCard
            backgroundImage="https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/recovery-rate.webp"
            title="회수율"
            description=""
            value="79%"
          />
          <StatCard
            backgroundImage="https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/suim-count.webp"
            title="수임건수"
            description="130여개 지역 전국 개인, 기업 고객"
            value={
              suimCount === null ? (
                <>
                  <CountSkeleton />+
                </>
              ) : (
                `${suimCount.toLocaleString()}+`
              )
            }
          />
        </div>
        <div className="flex-1">
          <TableDemo />
        </div>
      </div>
    </section>
  );
};
